/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { RuleEntity } from './RuleEntity.js';
import {
    RuleEntityFromJSON,
    RuleEntityFromJSONTyped,
    RuleEntityToJSON,
} from './RuleEntity.js';
import type { RuleResult } from './RuleResult.js';
import {
    RuleResultFromJSON,
    RuleResultFromJSONTyped,
    RuleResultToJSON,
} from './RuleResult.js';

/**
 * 
 * @export
 * @interface QARuleWithResult
 */
export interface QARuleWithResult {
    /**
     * 
     * @type {RuleResult}
     * @memberof QARuleWithResult
     */
    result?: RuleResult;
    /**
     * 
     * @type {RuleEntity}
     * @memberof QARuleWithResult
     */
    rule?: RuleEntity;
}

/**
 * Check if a given object implements the QARuleWithResult interface.
 */
export function instanceOfQARuleWithResult(value: object): boolean {
    return true;
}

export function QARuleWithResultFromJSON(json: any): QARuleWithResult {
    return QARuleWithResultFromJSONTyped(json, false);
}

export function QARuleWithResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): QARuleWithResult {
    if (json == null) {
        return json;
    }
    return {
        
        'result': json['result'] == null ? undefined : RuleResultFromJSON(json['result']),
        'rule': json['rule'] == null ? undefined : RuleEntityFromJSON(json['rule']),
    };
}

export function QARuleWithResultToJSON(value?: QARuleWithResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'result': RuleResultToJSON(value['result']),
        'rule': RuleEntityToJSON(value['rule']),
    };
}

